import dashboardsApi from 'common/src/modules/dashboards/dashboards.api';
import {refreshDashboardWidgets} from 'common/src/modules/dashboards/store/features';
import {Tool, ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {AccountAnalyticsToolName} from '../accountAnalyticsAgent.enums';

const inputSchema = z.object({
  dashboardId: z.number().describe('ID of dashboard to delete widget from'),
  widgetId: z.number().describe('ID of widget to delete'),
});

function deleteAccountWidgetTool(store: CLStore): Tool<typeof inputSchema> {
  async function execute({
    input: {widgetId, dashboardId},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    try {
      await dashboardsApi.deleteWidget(widgetId);

      store.dispatch(refreshDashboardWidgets({dashboardId}));

      return toolResult('Widget deleted successfully');
    } catch (error) {
      return toolResult('An error occurred while deleting the widget');
    }
  }

  return tool({
    name: AccountAnalyticsToolName.DeleteAccountWidget,
    displayName: 'Deleting Widget',
    description: 'Delete a widget from account dashboard',
    execute,
    inputSchema,
  });
}

export default deleteAccountWidgetTool;
